export default __webpack_public_path__ + "static/media/userManual.8efc7f0c.svg";